export interface Est3WbsNode {
  id: string;
  code: string;
  name?: string;
  parent_id?: string | null;
  parentId?: string | null;
  level_hint?: number;
  sort_order?: number;
  is_active?: number | boolean;
}

export interface Est3TreeNode {
  key: string;
  value: string;
  title: string;
  children?: Est3TreeNode[];
}

export function buildWbsTreeData(nodes: Est3WbsNode[]): Est3TreeNode[] {
  const byId = new Map<string, Est3TreeNode & { children: Est3TreeNode[] }>();
  for (const n of nodes) {
    const label = `${n.code} · ${n.name || n.code}`;
    byId.set(n.id, { key: n.id, value: n.id, title: label, children: [] });
  }
  const roots: Est3TreeNode[] = [];
  for (const n of nodes) {
    const node = byId.get(n.id)!;
    const parentId = n.parent_id || n.parentId;
    if (parentId && byId.has(parentId)) {
      byId.get(parentId)!.children.push(node);
    } else {
      roots.push(node);
    }
  }
  const prune = (list: Est3TreeNode[]): Est3TreeNode[] =>
    list.map((item) => {
      const kids = (item as Est3TreeNode & { children?: Est3TreeNode[] }).children;
      return kids?.length ? { ...item, children: prune(kids) } : { ...item, children: undefined };
    });
  return prune(roots);
}

export function buildWbsTableTree(nodes: Est3WbsNode[]): Array<Est3WbsNode & { key: string; children?: any[] }> {
  const byId = new Map<string, Est3WbsNode & { key: string; children: any[] }>();
  for (const n of nodes) {
    byId.set(n.id, { ...n, key: n.id, children: [] });
  }
  const roots: Array<Est3WbsNode & { key: string; children?: any[] }> = [];
  for (const n of nodes) {
    const node = byId.get(n.id)!;
    const parentId = n.parent_id || n.parentId;
    if (parentId && byId.has(parentId)) {
      byId.get(parentId)!.children.push(node);
    } else {
      roots.push(node);
    }
  }
  const prune = (list: any[]): any[] =>
    list.map((item) => ({
      ...item,
      children: item.children?.length ? prune(item.children) : undefined,
    }));
  return prune(roots);
}

export function wbsLabelById(nodes: Est3WbsNode[], id?: string | null): string {
  if (!id) return '—';
  const n = nodes.find((x) => x.id === id);
  return n ? `${n.code} · ${n.name || ''}` : id.slice(0, 8);
}

export function cbsLabelById(
  nodes: Array<{ id: string; code: string; name?: string }>,
  id?: string | null
): string {
  if (!id) return '—';
  const n = nodes.find((x) => x.id === id);
  return n ? `${n.code} · ${n.name || ''}` : id.slice(0, 8);
}

export function buildCbsTreeData(
  nodes: Array<{ id: string; code: string; name?: string; parent_id?: string | null }>
): Est3TreeNode[] {
  return buildWbsTreeData(
    nodes.map((n) => ({
      id: n.id,
      code: n.code,
      name: n.name,
      parent_id: n.parent_id,
    }))
  );
}
